var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 69,
    viewBox: "0 0 96 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96 1H79V18H96V1Z",
    fill: "url(#paint0_linear_54298_36958)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6034 68.9912C79.1054 68.9912 93.6054 55.9002 95.7095 39.0187C95.912 37.606 96 36.1671 96 34.7106V26.4278H79.1847V34.7106C79.1847 35.7284 79.0967 36.7374 78.9206 37.7113C78.1546 42.116 75.716 45.959 72.3001 48.5913C71.9655 48.8457 71.4725 48.7317 71.27 48.3544L70.6538 47.205L49.7798 8.02833C47.1387 3.0797 41.9356 0 36.1867 0C30.4378 0 25.2259 3.0797 22.5936 8.02833L1.71969 47.205C-0.701369 51.7588 -0.560506 57.111 2.10706 61.5332C4.88027 66.1396 9.81923 68.8859 15.3216 68.8859H31.8112V52.1273H18.2093C18.2093 52.1273 18.1565 52.0922 18.1741 52.0659L36.1515 18.3204C36.1515 18.3204 36.2131 18.2941 36.2219 18.3204L54.1994 52.0659C54.1994 52.0659 54.1994 52.1273 54.1642 52.1273H40.5974V68.8859L61.6034 69V68.9912Z",
    fill: "url(#paint1_linear_54298_36958)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_54298_36958",
    x1: 87.4956,
    y1: 18,
    x2: 87.4956,
    y2: 1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92278F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_54298_36958",
    x1: 48.0015,
    y1: 68.9912,
    x2: 48.0015,
    y2: -0.00877243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#662D91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92278F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logo-short.c69d3a705d41cd6a6883f006e8dd3a2a.svg";
export { ForwardRef as ReactComponent };